import i18n from 'src/i18n';

const configTable = () => {
  const tableColumns = [
    {
      prop: 'name',
      label: i18n.t('common_words.name'),
      sortable: true,
      minWidth: 160,
    },
    {
      prop: 'abbreviation',
      label: i18n.t('common_words.symbol'),
      sortable: true,
    },
    {
      prop: 'unit_formate',
      label: i18n.t('labor.unit_format'),
      sortable: true,
      minWidth: 115,
    },
  ];

  return { tableColumns };
};
export default configTable;
